// Actions
export const LOGIN = 'golagol/auth/actions/login';
export const LOGIN_SUCCESS = 'golagol/auth/actions/login_success';
export const LOGIN_ERROR = 'golagol/auth/actions/login_error';

export const FETCH_ACCOUNT = 'golagol/auth/actions/fetch_account';
export const FETCH_ACCOUNT_SUCCESS = 'golagol/auth/actions/fetch_account_success';
export const FETCH_ACCOUNT_ERROR = 'golagol/auth/actions/fetch_account_error';

export const LOGOUT = 'golagol/auth/actions/logout';
export const REFRESH_TOKEN = 'golagol/auth/actions/refresh_token';
export const REFRESH_TOKEN_SUCCESS = 'golagol/auth/actions/refresh_token_success';
export const REFRESH_TOKEN_ERROR = 'golagol/auth/actions/refresh_token_error';
export const ME = 'golagol/auth/actions/me';
export const ME_SUCCESS = 'golagol/auth/actions/me_success';
export const ME_ERROR = 'golagol/auth/actions/me_error';
// Getters
export const USERNAME = 'golagol/auth/getters/username';
export const USER_ID = 'golagol/auth/getters/userId';
export const USER_REAL_ID = 'golagol/auth/getters/userRealId';
export const FULLNAME = 'golagol/auth/getters/fullName';
export const EMAIL = 'golagol/auth/getters/email';
export const ACCOUNT_ID = 'golagol/auth/getters/accountId';
export const EDIT_INFO = 'golagol/auth/getters/edit';
export const IS_LOGGED_IN = 'golagol/auth/getters/isLoggedIn';
export const GET_LOGIN_ERROR = 'golagol/auth/getters/getLoginError';
export const LOADING_LOGIN = 'golagol/auth/getters/getLoginError';
export const ACCOUNT = 'golagol/auth/getters/account';
export const BALANCE = 'golagol/auth/getters/balance';
